export default __webpack_public_path__ + "static/media/polki4.111db98e.png";